// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"287":"97b295dd","545":"11da23b1"}[chunkId] + ".chunk.js";
};